import { paymentTypes } from 'config/types';
import { computed } from 'mobx';
import { groupByDate } from '../../../helpers/firebaseDataHelpers';

class PaymentsMapper {
  constructor(paymentsCollection) {
    this.collection_ = paymentsCollection;
  }

  get depositData() {
    return this.collection_.data?.filter(
      (paymentDoc) => paymentDoc.data.paymentType === paymentTypes.DEPOSIT
    );
  }

  get rentData() {
    return this.collection_.data?.filter(
      (paymentDoc) => paymentDoc.data.paymentType === paymentTypes.RENT
    );
  }

  get dataByDate() {
    return this.collection_.data ? groupByDate(this.collection_.data) : {};
  }
}

PaymentsMapper.annotations = {
  depositData: computed,
  rentData: computed,
  dataByDate: computed,
};

export default PaymentsMapper;
